
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(3 3)"}},[_c('rect',{attrs:{"width":"22","height":"19","y":"2","stroke":"#000","rx":"1.86"}}),_c('rect',{attrs:{"width":"3","height":"1.38","x":"2","y":"4.21","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"13","height":"1.38","x":"7","y":"4.21","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('path',{attrs:{"stroke":"#000","d":"M0 7.5h22"}}),_c('path',{attrs:{"fill":"#5CE8AD","fill-rule":"nonzero","d":"M15 13.429v1.142a.571.571 0 01-.571.572h-2.286v2.286a.571.571 0 01-.572.571H10.43a.571.571 0 01-.572-.571v-2.286H7.571A.571.571 0 017 14.57V13.43c0-.316.256-.572.571-.572h2.286v-2.286c0-.315.256-.571.572-.571h1.142c.316 0 .572.256.572.571v2.286h2.286c.315 0 .571.256.571.572z"}})])])
          )
        }
      }
    